
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.52","height":"9.215"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 5591"}},[_c('path',{attrs:{"data-name":"Path 5394","d":"M20.519 4.859c-.026.185-.042.373-.079.556a4.541 4.541 0 01-2.75 3.419 4.678 4.678 0 01-1.78.376 5.07 5.07 0 01-3.083-1.02 15.316 15.316 0 01-2.068-1.8l-.511-.51c-.2.207-.391.412-.589.609a13.96 13.96 0 01-1.94 1.669 5.671 5.671 0 01-2.288.977 4.612 4.612 0 01-3.79-.877 4.235 4.235 0 01-1.5-2.439 4.619 4.619 0 01.278-3.09A4.558 4.558 0 013.76.106a4.757 4.757 0 013.619.721A12.244 12.244 0 019.39 2.473c.25.243.5.49.742.737a1.724 1.724 0 01.118.151c.234-.238.441-.455.655-.666a13.7 13.7 0 011.939-1.653 5.7 5.7 0 012.225-.945 4.634 4.634 0 013.764.828 4.177 4.177 0 011.538 2.457c.065.281.087.572.129.859 0 .03.012.06.018.089zM9.011 4.615l-.718-.7a12.292 12.292 0 00-1.454-1.277 3.7 3.7 0 00-1.957-.76 2.632 2.632 0 00-2.047.742 2.707 2.707 0 00-.8 2.63 2.579 2.579 0 002.906 2.081 3.851 3.851 0 001.579-.557 9.49 9.49 0 001.8-1.465c.234-.227.46-.459.691-.694zm2.493 0c.544.514 1.074 1.027 1.62 1.524a5.2 5.2 0 001.3.884 2.941 2.941 0 002.383.137 2.766 2.766 0 001.707-3.035 2.612 2.612 0 00-3.125-2.21 4.215 4.215 0 00-1.656.7 14.381 14.381 0 00-2.228 2z","fill":"#28345c"}})])])
          )
        }
      }
    